// @flow

import * as React             from 'react';
import Link                   from 'react-router-dom/Link';
import * as Recompose         from 'recompose';
import Button                 from '../../../modules/reactstrap/components/Button';
import Card                   from '../../../modules/reactstrap/components/Card/Card';
import AcceptAllCookiesButton from './AcceptAllCookiesButton';
import mapUserCookieSettings  from './hocs/mapUserCookieSettings';


// -----------------------------------------------------------------------------------------------------------------
// Main component
// -----------------------------------------------------------------------------------------------------------------

export type CookiesDialogPresentationProps = {|
  cookieSettings_haveUserSettings: boolean,
|};

const CookiesDialogPresentation: React.ComponentType<CookiesDialogPresentationProps> =
        Recompose.setDisplayName('CookiesDialog')(
          ({cookieSettings_haveUserSettings}) => <div style={{
            position: 'fixed',
            bottom:   '1rem',
            right:    '1rem',
            width:    '22rem',
            maxWidth: 'calc(100% - 2rem)',
            zIndex:   9999,
          }}>
            <Card.Card color="tertiary">
              <Card.Header>Cookies!</Card.Header>
              <Card.Body>
                {
                  cookieSettings_haveUserSettings &&
                  <Card.Text>Our cookies have changed. We'd like to confirm you are still happy to continue using
                    thesite.</Card.Text>
                }
                <Card.Text>We need to store data in your browser to make the site work. Other data we need your
                  permission to store</Card.Text>

                <Card.Text> For more information visit the <Link to="/cookies">cookies settings page</Link>.</Card.Text>
                <AcceptAllCookiesButton/>
                {' '}
                <Button color="link" to="/cookies">Learn more</Button>
              </Card.Body>
            </Card.Card>
          </div>,
        );


const CookiesDialog = Recompose.compose(
  mapUserCookieSettings,

  Recompose.setDisplayName('HideIfCurrent'),
  Recompose.branch(
    props => props.cookieSettings_areUserSettingsCurrent,
    Recompose.renderNothing,
  ),

  Recompose.setDisplayName('PresentationProps'),
  Recompose.mapProps(
    props => ({cookieSettings_haveUserSettings: props.cookieSettings_haveUserSettings}),
  ),
)(CookiesDialogPresentation);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default CookiesDialog;



// WEBPACK FOOTER //
// ./src/components/profile/cookies/CookiesDialog.js